import { CALENDAR_VIEW, FILTER_TYPE } from "../../calendar-common/constants";

export const getViewDefaultSettings = (store) => {
    const { settings } = store;
    let nextSettings;
    if (settings.view == CALENDAR_VIEW.Configure_View_Default) {
        const { defaultSettings } = store;
        nextSettings = defaultSettings;
        nextSettings.actualFilterType = FILTER_TYPE.default;
    } else if (settings.view == CALENDAR_VIEW.Configure_View_Basic) {
        const { basicSettings } = store;
        nextSettings = basicSettings;
        nextSettings.actualFilterType = FILTER_TYPE.basic;
    }
    if (settings.timezoneOffset)
        nextSettings.timezoneOffset = settings.timezoneOffset;

    return nextSettings;
};
